import { Injectable } from '@angular/core';
import { HttpClientService } from './httpClient.service';
import { ConfigurationService } from './configuration.service';
import { map } from 'rxjs/operators';
import { NovoPagamento } from '../model/novopagamento.model';
import { Result } from 'src/app/model/result.model';
import { AdditionalPaymentData } from 'src/app/model/additionalPaymentData.model';

@Injectable()
export class PaymentService {
    apiUrl: string;
    private httpOptions : any;
   
    constructor(
        private http: HttpClientService,
        private configService: ConfigurationService
        ) {
            this.onConfigLoad = this.onConfigLoad.bind( this );
            configService.loadConfigurations().subscribe( this.onConfigLoad );
        }
        
        private onConfigLoad( config ) {
            this.apiUrl = config.apiUrl;
        }
        
        postPagamento(userId: Number, agenciaId: Number, protocolo: Number, novoPagamento: NovoPagamento) {
            const cookie = JSON.parse(localStorage.getItem('cookie'));
            return this.http.post<Result>(`${this.apiUrl}/back/integracao/payment/new?cookie=` + cookie + `&userId=` + userId + `&agenciaId=` + agenciaId + `&protocolo=` + protocolo, JSON.stringify(novoPagamento), { 'Content-Type': 'application/json', "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}` }).pipe(map(response => response));
        }
        
        getAdditionalPaymentData(agenciaId: Number, serviceId: Number, zipCode: String) {
            const cookie = JSON.parse(localStorage.getItem('cookie'));
            this.getAuthToken();
            return this.http.get<AdditionalPaymentData>(`${this.apiUrl}/back/integracao/additionalPaymentData?cookie=` + cookie + `&agenciaId=` + agenciaId + `&serviceId=` + serviceId + `&zipCode=` + zipCode, this.httpOptions).pipe(map(response => response)).pipe(map(response => response));
        }
        
        private getAuthToken(){
            this.httpOptions = { "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}` };
        }
    }
    